// external
import { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// components
import Loader from "components/partials/loader/loader";
import StepNavigation from "components/StepNavigation";
import CustomTextInput from "components/partials/custom-text-input/custom-text-input";
import ProgressTracker from "components/ProgressTracker";
import FaoBuilderHeader from "../fao-layout/fao-builder-header";

// state managing/security
import { FaoBuilderContext } from "context/FaoBuilderContext";
import useTuitionData from "../hooks/use-tuition-data";

// css/styling
import { STYLES } from "../constants/styles.constants";

function FaoTuition() {
  const { modelConfig } = useContext(FaoBuilderContext);

  const {
    tuitionBase,
    tuitionAdjusted,
    loading,
    handleAdjustedChange,
    saveTuition,
    isSaved,
    isSaving,
  } = useTuitionData();
  const navigate = useNavigate();

  const isInvalidValue = (value) => {
    return (
      value === 0 ||
      !value ||
      value === null ||
      value === undefined ||
      value === "No Base Value"
    );
  };
  const tuitionChange = useMemo(() => {
    if (isInvalidValue(tuitionBase.tuition)) return "No Base Value";
    return (
      (100 * (tuitionAdjusted.tuition - tuitionBase.tuition)) /
      tuitionBase.tuition
    ).toFixed(2);
  }, [tuitionBase, tuitionAdjusted]);

  const coaChange = useMemo(() => {
    if (isInvalidValue(tuitionBase.coa)) return "No Base Value";
    return (
      (100 * (tuitionAdjusted.coa - tuitionBase.coa)) /
      tuitionBase.coa
    ).toFixed(2);
  }, [tuitionBase, tuitionAdjusted]);

  const renderCostInput = (label) => {
    const key = label.toLowerCase();
    return (
      <div className="flex gap-5">
        <CustomTextInput
          id={`current_${key}`}
          required={true}
          label={`Current ${label}`}
          labelInTop={true}
          value={tuitionBase[key].toLocaleString()}
          disabledClassName="bg-gray-01 cursor-not-allowed"
          customClass={STYLES.label}
          inputWrapperCustomClass="h-10"
          disabled={true}
        />
        <CustomTextInput
          id={`new_${key}`}
          required={true}
          label={`New ${label}`}
          labelInTop={true}
          customClass={STYLES.label}
          inputWrapperCustomClass="h-10"
          value={tuitionAdjusted[key].toLocaleString()}
          type="text"
          onChange={(e) => handleAdjustedChange(key, e.target.value)}
        />
        <div className="relative flex h-full">
          <div className="relative w-[200px]">
            <CustomTextInput
              id={`${key}_change`}
              required={true}
              label={`${label} Change`}
              labelInTop={true}
              customClass={STYLES.label}
              disabledClassName="bg-gray-01 cursor-not-allowed"
              value={key === "tuition" ? tuitionChange : coaChange}
              disabled={true}
            />
            <div className="absolute right-2 top-[42px] mb-1 translate-y-1/2 transform">
              %
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <ToastContainer />
      <FaoBuilderHeader
        modelName={modelConfig.versionName}
        modelId={modelConfig.id}
      />
      <ProgressTracker />
      {loading ? (
        <Loader />
      ) : (
        <div>
          {renderCostInput("Tuition")}
          {renderCostInput("COA")}
        </div>
      )}
      <StepNavigation
        onClickBack={() =>
          navigate(`../fao-builder/${modelConfig.id}/regime-config`)
        }
        isSaving={isSaving}
        isSaved={isSaved}
        disabledNext={!isSaved}
        onClickSave={saveTuition}
        onClickNext={() =>
          navigate(`../fao-builder/${modelConfig?.id}/awarding-strategy`)
        }
      />
    </div>
  );
}

export default FaoTuition;
